export const getinwordstatus = (state = [], action) => {
  switch (action.type) {
    case "INWORD_STATUS":
      return action.payload.data;
    default:
      return state;
  }
};
